// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"42ae613f","205":"f0a8b944","548":"7fd88d3f","770":"4a007824"}[chunkId] + ".chunk.js";
};